export const DOMAINS_USER_SELECTION = "DOMAINS_USER_SELECTION";

const ALL = {
  DOMAINS_USER_SELECTION,
};
export default ALL;
